// @flow

import _ from 'lodash';

import { formatDateTime } from '@zapier/date';

import type { FlowTaskState } from 'app/beta-editor/flowState';
import type { TriggerSamples } from 'app/beta-editor/components/SamplePage';

export const ZAP_META_ID = '_zap_data_sample_id';

export const getBrowserTimestamp = () => {
  const date = new Date();
  return formatDateTime(date, 'exhaustive');
};

export const findIndexOfSelectedSample = (
  selectedSampleId: number,
  triggerSamples: TriggerSamples
) => {
  return _.findIndex(
    triggerSamples,
    sample => sample[ZAP_META_ID] === selectedSampleId
  );
};

export const getFirstSampleMetaId = (triggerSamples: TriggerSamples) => {
  return _.get(_.first(triggerSamples), [ZAP_META_ID]);
};

export const getSelectedSampleId = ({
  taskState,
  samples,
  selectedSampleId,
}: {
  selectedSampleId?: number,
  taskState: FlowTaskState,
  samples: TriggerSamples,
}) => {
  return (
    selectedSampleId ||
    _.get(taskState, ['selected_sample']) ||
    _.get(samples, ['0', ZAP_META_ID])
  );
};

export const getSelectedSample = ({
  taskState,
  samples,
  selectedSampleId,
}: {
  selectedSampleId?: number,
  taskState: FlowTaskState,
  samples: TriggerSamples,
}) => {
  // if we have multiple samples, then find the selected one
  if (_.isArray(samples)) {
    const targetSampleId = getSelectedSampleId({
      taskState,
      samples,
      selectedSampleId,
    });
    return _.find(samples, sample => sample[ZAP_META_ID] === targetSampleId);
  } else {
    // if not, we can assume we only have one sample, so just return that one
    return samples;
  }
};
